<div class="wrapper">
  <p class="subject">{{ state().modal.subject | translate: state().modal.translateParams }}</p>
  <p class="info">{{ state().modal.info | translate: state().modal.translateParams }}</p>
  <div class="buttons">
    <app-button-ldb label="LAYOUT.Cancel" type="secondary" (click)="onCancel()" />
    <app-submit-spinner [loading]="loading()" label="LAYOUT.Accept" (click)="onAccept()" />
  </div>
</div>
@if (sub$ | async) {}
